import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/app/App'
import ErrorBoundary from '@/components/ErrorBoundary'
import '@/styles/globals.css'
import './i18n'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
